import React from "react";

interface ArticleBannerProps {
  title: string;
  bgColor?: string;
}

export function ArticleBanner({ title, bgColor = "bg-amber-600" }: ArticleBannerProps) {
  return (
    <div className="w-full bg-guru-floral-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="relative flex items-center h-24 md:h-20">
          <div className={`absolute left-0 top-0 bottom-0 w-60 md:w-68 ${bgColor} rounded-r-3xl`}></div>
          <div className="relative z-10 pl-20 md:pl-28">
            <h1 className="text-2xl md:text-3xl font-bold text-zinc-800 ml-40">{title}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArticleBanner;
